import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const deleteQuickLink = async (id: number) => {
	const response = await cmsClient.delete(`/homepage/admin/quicklink/${id}/`);

	return response.data;
};

const useDeleteQuickLink = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast type="Success" message="Quick link has been deleted" />,
			{ hideProgressBar: true }
		);

		queryClient.invalidateQueries(["quick-links"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(deleteQuickLink, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useDeleteQuickLink;
